/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S1_BodyInputs */

const tr_cerez_s1_body = /** @type {(inputs: Cerez_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerezler, bir internet sitesini ziyaret ettiğinizde tarayıcınıza yerleştirilen küçük metin dosyalarıdır. Sayfanın doğru çalışmasını, tercihlerinizin hatırlanmasını ve hizmetin iyileştirilmesini sağlar.`)
};

const en_cerez_s1_body = /** @type {(inputs: Cerez_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies are small text files placed in your browser when you visit a website. They ensure that the page works correctly, that your preferences are remembered and that the service can be improved.`)
};

const de_cerez_s1_body = /** @type {(inputs: Cerez_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies sind kleine Textdateien, die beim Besuch einer Internetseite in Ihrem Browser abgelegt werden. Sie sorgen dafür, dass die Seite korrekt funktioniert, dass Ihre Einstellungen gespeichert bleiben und dass der Dienst verbessert werden kann.`)
};

const ru_cerez_s1_body = /** @type {(inputs: Cerez_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файлы cookie представляют собой небольшие текстовые файлы, которые размещаются в вашем браузере при посещении веб-сайта. Они обеспечивают корректную работу страницы, сохранение ваших предпочтений и улучшение сервиса.`)
};

/**
* | output |
* | --- |
* | "Cookies are small text files placed in your browser when you visit a website. They ensure that the page works correctly, that your preferences are remembered..." |
*
* @param {Cerez_S1_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s1_body = /** @type {((inputs?: Cerez_S1_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S1_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s1_body(inputs)
	if (locale === "de") return de_cerez_s1_body(inputs)
	if (locale === "ru") return ru_cerez_s1_body(inputs)
	return tr_cerez_s1_body(inputs)
});